export function LogoMark({ className = "h-9 w-9" }) {
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
      <defs>
        <linearGradient id="pdl-g" x1="0" y1="1" x2="1" y2="0">
          <stop offset="0" stopColor="#8B7CFF" />
          <stop offset="0.55" stopColor="#F3E5AB" />
          <stop offset="1" stopColor="#FF9A3C" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx="14" fill="#090C10" />
      <path
        d="M20 52V30a12 12 0 0 1 24 0v22"
        fill="none"
        stroke="url(#pdl-g)"
        strokeWidth="3.6"
        strokeLinecap="round"
      />
      <path d="M14 52h36" stroke="#F3E5AB" strokeWidth="3.6" strokeLinecap="round" />
      <path d="M32 14v-4M22 17l-2.4-3.4M42 17l2.4-3.4" stroke="#F3E5AB" strokeWidth="2.4" strokeLinecap="round" />
      <circle cx="32" cy="37" r="3" fill="#F3E5AB" />
    </svg>
  );
}

export const Logo = ({ compact = false }) => (
  <span className="flex items-center gap-3">
    <LogoMark />
    {!compact && (
      <span className="font-serif text-xl tracking-wide text-white">
        Porte <span className="italic text-gold-light">de</span> Lumière
      </span>
    )}
  </span>
);
